// extracted by mini-css-extract-plugin
module.exports = {"customer":"Customer_customer__2qdFl","edited":"Customer_edited__1MGz0","details":"Customer_details__1QJ-Z","iserp":"Customer_iserp__1Hj50","noerp":"Customer_noerp__28dfM"};